export const PHONE_DISPLAY = "(03) 5024 5570";
export const PHONE_TEL = "tel:+61350245570";
export const ADDRESS = "126A Eighth St, Mildura VIC 3500";

export const HOURS = [
  { days: "Mon — Thu", time: "10:00 AM — 1:00 AM" },
  { days: "Fri — Sat", time: "10:00 AM — 3:00 AM" },
  { days: "Sunday", time: "10:00 AM — 1:00 AM" },
];

export const MENU = [
  {
    id: "classic-pizza",
    title: "Classic Pizza",
    notes: [
      '11" Regular $16 · 13" Large $20 · 15" Family $24',
      "Extra toppings / half & half: Reg +$2 · Lrg +$3 · Fam +$4",
    ],
    items: [
      { name: "Avanti's Special", desc: "Tomato base, ham, pepperoni, cabanossi, chicken, mushroom, onion, capsicum, moz. cheese" },
      { name: "Hawaiian", desc: "Tomato base, ham, pineapple, moz. cheese" },
      { name: "Supreme", desc: "Tomato base, ham, pepperoni, onion, cabanossi, pineapple, mushroom, capsicum, moz. cheese" },
      { name: "Mexicana", desc: "Tomato base, pepperoni, onion, capsicum, jalapeño, chilli flakes, moz. cheese" },
      { name: "Capricciosa", desc: "Tomato base, ham, mushroom, olives, mozzarella cheese" },
      { name: "Mix Kebab Pizza", desc: "Tomato base, chicken, beef, capsicum, mushroom, onion, moz. cheese" },
      { name: "Aussie", desc: "Tomato base, shredded ham, turkey bacon, egg, mozzarella cheese" },
      { name: "Vegetarian", desc: "Tomato base, mushroom, onion, capsicum, pineapple, tomato, olives, moz. cheese" },
      { name: "Garlic Prawns", desc: "Garlic base, prawns, moz. cheese" },
      { name: "Eggplant", desc: "Tomato base, roasted eggplant, spinach, roasted capsicum, moz. cheese drizzled w/ garlic sauce" },
      { name: "Meat Lovers", desc: "BBQ base, shredded ham, pepperoni, cabanossi, turkey bacon, moz. cheese" },
      { name: "Pepperoni", desc: "Tomato base, pepperoni, moz. cheese" },
      { name: "Beef Pizza", desc: "BBQ base, shredded beef, mushroom, onion, capsicum, mozzarella cheese" },
      { name: "BBQ Chicken", desc: "BBQ base, marinated chicken, mushroom, onion, capsicum, mozzarella cheese" },
      { name: "Peri Peri Chicken", desc: "Tomato base, marinated chicken, mushroom, capsicum, onion, mozzarella cheese drizzled with peri peri sauce" },
      { name: "Tandoori Chicken", desc: "Tandoori base, chicken, capsicum, onion, moz. cheese drizzled w/ garlic yogurt sauce" },
      { name: "Chicken Hawaiian", desc: "BBQ base, chicken, capsicum, pineapple, mozzarella cheese" },
      { name: "Spicy Chicken", desc: "Chilli base, marinated chicken, mushroom, onion, jalapeño, chilli flakes, mozzarella cheese" },
      { name: "Mediterranean Lamb", desc: "Garlic chilli base, lamb, mushroom, capsicum, onion, tomato, mozzarella cheese drizzled with garlic yogurt sauce" },
      { name: "Four Cheese", desc: "Pesto base, feta cheese, mozzarella cheese, bocconcini cheese, parmesan cheese" },
      { name: "Margarita", desc: "Tomato base, tomato, moz. cheese" },
      { name: "Garlic Pizza", desc: "Garlic base, feta cheese, moz. cheese" },
      { name: "Make Your Own Pizza", desc: "Choose your base with 4 toppings and mozzarella cheese" },
      { name: "Garlic Bread", price: "$7" },
    ],
  },
  {
    id: "gozleme",
    title: "Gozleme",
    notes: ["All $14 — served with lemon wedges", "Extra topping +$2 · Dip in container +$2"],
    items: [
      { name: "Spinach & Cheese" },
      { name: "Spinach, Mushroom & Cheese" },
      { name: "Chicken, Spinach & Cheese" },
      { name: "Chicken, Mushroom & Cheese" },
      { name: "Beef, Spinach & Cheese" },
      { name: "Beef, Mushroom & Cheese" },
      { name: "Cheese Lovers" },
      { name: "Chicken, Potato & Cheese" },
      { name: "Potato, Spinach & Cheese" },
    ],
  },
  {
    id: "pides",
    title: "Pides",
    notes: ["All $18 — served with lemon wedges", "Extra topping +$2 · Dip in container +$2"],
    items: [
      { name: "Avanti's Special", desc: "Chicken, mushroom, capsicum, onion, spinach, Turkish salami, mozzarella & feta cheese" },
      { name: "Vegetarian Pide", desc: "Spinach, mushroom, onion, capsicum, tomato, mozzarella & feta cheese" },
      { name: "Chicken Pide", desc: "Chicken, mushroom, capsicum, onion, mozzarella & feta cheese" },
      { name: "Beef Pide", desc: "Beef, capsicum, mushroom, onion, BBQ sauce, mozzarella & feta cheese" },
      { name: "Lamb Pide", desc: "Lamb, capsicum, onion, parsley, mushroom, tomato, mozzarella & feta cheese" },
      { name: "Turkish Salami Pide", desc: "Turkish salami, egg, mozzarella & feta cheese" },
      { name: "Potato Pide", desc: "Marinated potato, onion, spinach, mozzarella & feta cheese" },
      { name: "Garlic Pide", desc: "Garlic, parsley, mozzarella & feta cheese" },
      { name: "Spinach Pide", desc: "Spinach, egg, mozzarella & feta cheese" },
      { name: "Eggplant Pide", desc: "Roasted eggplant, roasted capsicum, spinach, onion, mozzarella & feta cheese drizzled with garlic yogurt sauce" },
      { name: "Cheese Pide", desc: "Mozzarella & feta cheese" },
      { name: "Mexicana Pide", desc: "Pepperoni, onion, jalapeno, capsicum, chilli flakes, mozzarella & feta cheese" },
      { name: "Chicken Spinach Pide", desc: "Marinated chicken, spinach, tomato, mozzarella & feta cheese" },
      { name: "Chicken Potato Pide", desc: "Chicken, potato, onion, mushroom, mozzarella & feta cheese" },
    ],
  },
  {
    id: "salads",
    title: "Salads",
    notes: ["All $10"],
    items: [
      { name: "Chicken Caesar", desc: "Chicken, lettuce, croutons, parmesan cheese & Caesar dressing" },
      { name: "Greek Salad", desc: "Tomato, onion, capsicum, cucumber, olive, feta cheese served with salad dressing" },
      { name: "Tabouli", desc: "Finely chopped veggies & parsley, bulgur with salad dressing" },
    ],
  },
  {
    id: "desserts",
    title: "Desserts",
    items: [
      { name: "Baklava", price: "$4" },
      { name: "Choclava", price: "$4" },
      { name: "Turkish Delight", price: "$2" },
    ],
  },
  {
    id: "kebabs",
    title: "Kebabs",
    notes: ["Extra meat +$3 · Extra cheese +$2 · Extra falafel ball +$2 ea", "Mayo / peri peri / sour cream / aioli / hummus +$1 ea · Tabouli / olive / jalapeño / pineapple / mushroom +$2 ea"],
    groups: [
      {
        label: "Rolls",
        desc: "Served with lettuce, tomato, onion & 2 sauces",
        items: [
          { name: "Beef", price: "$17" },
          { name: "Chicken", price: "$17" },
          { name: "Mixed", price: "$17" },
          { name: "Lamb", price: "$18" },
          { name: "Falafel", price: "$14" },
        ],
      },
      {
        label: "Plates",
        desc: "Served with salad, tabouli, sauce, rice or bread",
        items: [
          { name: "Beef", price: "$22" },
          { name: "Chicken", price: "$22" },
          { name: "Mixed", price: "$22" },
          { name: "Lamb", price: "$23" },
          { name: "Falafel", desc: "5 falafel balls, lettuce, tomato, onion, tabouli & bread", price: "$18" },
        ],
      },
    ],
  },
  {
    id: "hsp",
    title: "HSP Snack Packs",
    blurb: "Hot chips, rice or salad loaded with your choice of meat and any 2 sauces.",
    notes: ["Extra meat: Small +$2 · Medium +$3 · Large +$4", "Cheese / olive / jalapeño / pineapple +$2 · Mayo / peri peri / sour cream / aioli / hummus +$1 ea"],
    items: [
      { name: "Beef", price: "S $20 · M $25 · L $30" },
      { name: "Chicken", price: "S $20 · M $25 · L $30" },
      { name: "Mixed", price: "S $20 · M $25 · L $30" },
      { name: "Lamb", price: "S $22 · M $27 · L $32" },
    ],
  },
  {
    id: "meat-box",
    title: "Just Meat Box",
    notes: ["Extra meat: Small +$2 · Medium +$3 · Large +$4"],
    items: [
      { name: "Beef", price: "S $25 · M $30 · L $35" },
      { name: "Chicken", price: "S $25 · M $30 · L $35" },
      { name: "Mixed", price: "S $25 · M $30 · L $35" },
      { name: "Lamb", price: "S $30 · M $35 · L $40" },
    ],
  },
  {
    id: "baked-potato",
    title: "Baked Potato",
    notes: ["All $14 — served with sour cream", "Extra topping +$2"],
    items: [
      { name: "Mince", desc: "Marinated mince & cheese" },
      { name: "Mexican", desc: "Marinated spicy mince & cheese" },
      { name: "Aussie", desc: "Ham (halal), pineapple & cheese" },
      { name: "Beef", desc: "Beef, mushroom, onion, capsicum & cheese" },
      { name: "Chicken", desc: "Chicken, mushroom, onion, capsicum & cheese" },
      { name: "Veggie", desc: "Spinach, mushroom, onion, capsicum, tomato & cheese" },
    ],
  },
  {
    id: "beef-burgers",
    title: "Beef Burgers",
    items: [
      { name: "Cheese Burger", desc: "Premium wagyu beef with melted American cheese, diced Spanish onions & dill pickles with burger sauce and ketchup", price: "$10" },
      { name: "Old School Burger", desc: "Premium wagyu beef, crisp coral lettuce, sliced tomato, onion, dill pickles, burger sauce & ketchup on a toasted milk bun", price: "$12" },
      { name: "The Thunder", desc: "Premium wagyu beef, crisp coral lettuce, jalapeño, onion, hash brown, maple beef rasher, melted American cheese, sriracha mayo sauce & burger sauce on a toasted milk bun", price: "$12" },
      { name: "Double Decker", desc: "Double premium wagyu beef with melted American cheese, maple beef rasher, dill pickles, crisp coral lettuce, sliced tomato, diced Spanish onion with burger sauce & ketchup", price: "$16" },
    ],
  },
  {
    id: "chicken-burgers",
    title: "Chicken Burgers",
    notes: ["Extras: meat or chicken patty +$6 ea · turkey bacon +$2 · beef rasher +$2 · cheese +$2 · egg +$2 · jalapeño +$2 · pineapple +$2"],
    items: [
      { name: "Classic Chicken", desc: "Southern fried chicken, melted American cheese, crisp coral lettuce, burger sauce on a toasted milk bun", price: "$10" },
      { name: "Southern Chooks", desc: "Southern fried chicken, turkey bacon, crisp coral lettuce, hash brown, peri peri sauce on a toasted milk bun", price: "$12" },
      { name: "Chooklicious", desc: "Southern fried chicken with melted American cheese, crisp coral lettuce, sliced tomato with special burger sauce & aioli sauce on a toasted milk bun", price: "$12" },
    ],
  },
  {
    id: "loaded-fries",
    title: "Loaded Fries",
    items: [
      { name: "Spicy Fries", desc: "Large size fries, parmesan cheese, jalapeño, cracked turkey bacon topped with sriracha mayo", price: "$14" },
      { name: "Chicken Pops", desc: "Large size fries, southern chicken popcorn, parmesan cheese topped with Avanti sauce", price: "$20" },
      { name: "Buffalo Chicken", desc: "Southern style fried chicken thigh pieces, powder parmesan cheese, chilli and ranch sauce", price: "$20" },
    ],
  },
  {
    id: "chicken-wings",
    title: "Chicken Wings",
    notes: ["3 pcs $7 · 6 pcs $12 · 12 pcs $22 · 24 pcs $40", "Flavours: Original · Smokey BBQ · Spicy Buffalo · Soy & Sweet · Korean BBQ"],
    items: [],
  },
  {
    id: "fries-sides",
    title: "Fries & Sides",
    items: [
      { name: "Nuggets & Chips", price: "6 pcs $10 · 12 pcs $16" },
      { name: "Fish & Chips", price: "$14" },
      { name: "Hash Brown", price: "$3 ea" },
      { name: "Hot Chips", price: "Small $8 · Large $10" },
    ],
  },
  {
    id: "deals",
    title: "Deals",
    notes: ["Combo add-on: regular hot chips + 375ml soft drink or bottle water added to any meal +$9"],
    items: [
      { name: "Deal One", desc: "1x Classic Pizza, 1x Garlic Bread, 1.25L Bottle Drink — your choice of drink flavour at pickup", price: "Reg $26 · Lrg $30 · Fam $34" },
      { name: "Deal Two", desc: "2x Classic Pizza, 1x Garlic Bread, 1x 1.25L Bottle Drink — your choice of drink flavour at pickup", price: "Reg $40 · Lrg $50 · Fam $58" },
      { name: "Deal Three", desc: "2x Regular Kebab, 1x Large Chips, 2x 375ml Can of Drink — your choice of drink flavours at pickup", price: "$44" },
      { name: "Deal Four", desc: "2x Turkish Pide, 1x Garlic Bread, 1x 1.25L Bottle Drink — your choice of drink flavour at pickup", price: "$48" },
    ],
  },
  {
    id: "drinks",
    title: "Drinks",
    items: [
      { name: "375ml Can", desc: "Coke, Coke Zero, Pepsi, Pepsi Max, Sunkist, Mtn Dew, Solo, Creaming Soda, Pasito, Ginger Beer", price: "$3 ea" },
      { name: "Juice & Ginger Beer", desc: "Orange juice, apple juice or ginger beer", price: "$6 ea" },
      { name: "1.25L Bottle", desc: "Pepsi, Pepsi Max, Sunkist, Solo, Pasito, Ginger Beer, Mtn Dew", price: "$7 ea" },
      { name: "Gatorade", desc: "Blue or lemon", price: "$6 ea" },
    ],
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/14779249/pexels-photo-14779249.jpeg?auto=compress&cs=tinysrgb&w=1920",
  flame: "https://images.pexels.com/photos/17326174/pexels-photo-17326174.jpeg?auto=compress&cs=tinysrgb&w=1920",
  shopFront: "/photos/shop-4.jpg",
  shopInterior: "/photos/shop-2.jpg",
  shopSeating: "/photos/shop-1.jpg",
  shopNight: "/photos/shop-3.jpg",
  pizza: "https://images.unsplash.com/photo-1593504049359-74330189a345?q=80&w=1200&auto=format&fit=crop",
  skewers: "https://images.unsplash.com/photo-1603360946369-dc9bb6258143?q=80&w=1200&auto=format&fit=crop",
  neon: "https://images.unsplash.com/photo-1562016825-b1c7cd4e8deb?q=80&w=1400&auto=format&fit=crop",
  oven: "https://images.pexels.com/photos/36707034/pexels-photo-36707034.jpeg?auto=compress&cs=tinysrgb&w=1400",
};
